import { Action, ActionType, PageType, State } from "../types";

export const handleVerifierTerms = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.VERIFIER_TERMS_BACK_CLICKED: {
      return {
        ...state,
        page: PageType.REVIEW_DETAILS,
      };
    }

    default: {
      return state;
    }
  }
};
